// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { MenuConfigService } from './menu-config.service';
import { environment } from 'environments/environment';

@Injectable()
export class MenuAsideService {
	// Public properties
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	/**
	 * Service constructor
	 *
	 * @param menuConfigService: MenuConfigService
	 */
	constructor(private menuConfigService: MenuConfigService) {
		// this.loadMenuPhanQuyen();
		// this.loadMenu();
		this.loadMenuPhanQuyen();
	}


	loadMenuPhanQuyen() {

		//lấy menu phân quyền
		var fs_Assign = (dt: any) => {
			let config = {
				header: {
					self: {},
					items: []
				},
				aside: {
					self: {},
					items: []
				}
			};
			let arr = [];

			let _module = {
				title: 'Trang chủ',
				root: true,
				icon: 'flaticon-home-2',
				page: '/'
			};
			config.aside.items.push(_module);

			dt.forEach((item, index) => {
				if(item.ChildMenu.length > 0){
					let _module = {
						title: '' + item.Title,
						root: item.ChildMenu ? item.ChildMenu.length > 0 : true,
						icon: '' + item.Icon,
					}

					if (item.ChildMenu.length > 0) {

						_module["bullet"] = 'dot';
						_module["submenu"] = [];

						item.ChildMenu.forEach((itemE, indexE) => {
							let _mainmenu = {
								title: '' + itemE.Title,
								root: itemE.ChildMenu ? itemE.ChildMenu.length == 0 : true,
								page: '' + itemE.Link,
							};
							if(itemE.ChildMenu.length > 0 || itemE.Link == '/'){
								_mainmenu["bullet"] = 'dot';
								_mainmenu["submenu"] = [];
								itemE.ChildMenu.forEach((itemEE, indexEE) => {
									let _submenu = {
										title: '' + itemEE.Title,
										page: '' + itemEE.Link,
										idLoaiHH: itemEE.Position
									};
									_mainmenu["submenu"].push(_submenu);

								});
								_module["submenu"].push(_mainmenu);
							}else{
								let _submenu = {
									title: '' + itemE.Title,
									page: '' + itemE.Link,
									idLoaiHH: itemE.Position
								};
								_module["submenu"].push(_submenu);
							}

						});

					}

					config.aside.items.push(_module);
				}else{
					if(item.Link!='#'){
						let _module = {
							title: '' + item.Title,
							root: item.ChildMenu ? item.ChildMenu.length == 0 : true,
							icon: '' + item.Icon,
							page: '' + item.Link
						};
						config.aside.items.push(_module);
					}
				}
			});
			return config;
		}
		var menu_config = environment.nfc_jeeerp;
		this.menuConfigService.GetMenuPhanQuyen(menu_config).subscribe(res => {
			var s = {};
			if (res && res.status == 1)
				s = fs_Assign(res.data);
			const menuItems: any[] = objectPath.get(s, 'aside.items');
			this.menuConfigService.configModel.defaults = fs_Assign(res.data);
				this.menuConfigService.onMenuUpdated$.subscribe(model => {
					setTimeout(() =>
						this.menuList$.next(objectPath.get(model.defaults, 'aside.items'))
					);
				});
			//this.menuList$.next(menuItems);

		});
	}
	/**
	 * Load menu list
	 */
	loadMenu() {
		// get menu list
		const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');

		this.menuList$.next(menuItems);
	}
}
